import { Breadcrumb, Card, Layout, Row } from 'antd'
import ReportCards from '../../../components/Corporate/Analytics/ReportCards'
import PageTitle from '../../../elements/PageTitle'
import React, { Fragment } from 'react'

const { Content } = Layout

function Analytics(props) {
  return (
    <Fragment>
      <Content style={{ margin: '0px 0px' }}>
        <Card>
          <Row>
            <Breadcrumb>
              <Breadcrumb.Item href="#/">Home</Breadcrumb.Item>
              <Breadcrumb.Item>Corporates</Breadcrumb.Item>
              <Breadcrumb.Item href="#/corporates/analytics">Analytics</Breadcrumb.Item>
            </Breadcrumb>
            <PageTitle
              title={'Business Analytics Reports'}
              subtitle={'This is the Reports area'}
              color={'#427035'}
              iconType={'file-unknown'}
            />
          </Row>
        </Card>
        <Row gutter={16} style={{ padding: 10 }}>
          <ReportCards />
        </Row>
      </Content>
    </Fragment>
  )
}

Analytics.propTypes = {}
Analytics.defaultProps = {}

export default Analytics
